<template>
    <div @click="scrollToTop()" :class="['back-to-top-btn', { 'go-top': isTop }]">
        <i>
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m5 15 7-7 7 7" />
            </svg>
        </i>

        <i>
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m5 15 7-7 7 7" />
            </svg>
        </i>
    </div>
</template>

<script>
export default {
    name: 'GoTop',
    data() {
        return {
            isTop: false
        }
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },
    mounted() {
        const that = this
        window.addEventListener('scroll', () => {
            let scrollPos = window.scrollY
            if (scrollPos >= 100) {
                that.isTop = true
            } else {
                that.isTop = false
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.back-to-top-btn {
    position: fixed;
    cursor: pointer;
    bottom: 100%;
    right: 15px;
    background-color: #fff;
    z-index: 1000;
    width: 40px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    transition: .9s;
    border-radius: 50%;
    border: 1px solid #09445D;

    i {
        position: absolute;
        color: #09445D;
        top: 44%;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0;
        right: 0;
        margin: 0 auto;
        -webkit-transition: 0.2s;
        -o-transition: 0.2s;
        transition: 0.2s;
        font-size: 20px;

        &:last-child {
            opacity: 0;
            visibility: visible;
            top: 60%;
        }
    }

    &:hover,
    &:focus {
        color: #fff;

        &::before {
            opacity: 1;
            visibility: visible;
        }
    }

    &.go-top {
        bottom: 20px;
    }
}
</style>